import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/lgpd/_components/lgpd-request-form.tsx");
